import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Cloud, Zap, LogOut, Settings, Home } from 'lucide-react';

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-gray-900 border-b border-gray-700 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <Cloud className="h-8 w-8 text-cyan-400" />
            <Zap className="h-8 w-8 text-amber-400" />
            <div>
              <h1 className="text-xl font-bold text-white">
                Weather Ads Automation
              </h1>
              <p className="text-xs text-gray-400">
                Smart bid adjustments based on weather
              </p>
            </div>
          </button>

          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-medium text-white">
                {user?.email}
              </p>
              <p className="text-xs text-gray-400">
                {user?.role}
              </p>
            </div>

            <button
              onClick={() => navigate('/dashboard')}
              className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-gray-600 transition-all"
              title="Home"
            >
              <Home className="h-5 w-5 text-gray-300" />
            </button>

            <button
              onClick={() => navigate('/settings')}
              className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-gray-600 transition-all"
              title="Settings"
            >
              <Settings className="h-5 w-5 text-gray-300" />
            </button>

            <button
              onClick={handleLogout}
              className="p-2 rounded-lg bg-gray-800 hover:bg-red-900/30 border border-gray-700 hover:border-red-700 transition-all"
              title="Logout"
            >
              <LogOut className="h-5 w-5 text-gray-300 hover:text-red-400" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
